import AdminDashboardLayout from "components/layout/dashboard";
import FormBuilderLayout from "components/layout/form-builder/layout";
import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import ErrorBoundary from "components/HOC/ErrorBoundary";
import Loader from "components/UI/Loader";
import "config/handson-table.config";

// pages
const ManageCompanies = lazy(() => import("pages/admin/Company"));
const FormBuilderPage = lazy(() => import("pages/form-builder"));
const Home = lazy(() => import("pages/admin/Home"));
const ManageNewsLetters = lazy(() => import("pages/admin/news-letter"));
const NotFoundPage = lazy(() => import("pages/admin/NotFound"));
const ManageShareHolders = lazy(() => import("pages/admin/shareholders"));
const ManageStayUpdated = lazy(() => import("pages/admin/stay-updated"));
const ManageUserWalletSell = lazy(() => import("pages/admin/wallet-sell"));
const ManageUserWalletBuy = lazy(() => import("pages/admin/wallet-buy"));
const ManageCompanyNDA = lazy(() => import("pages/admin/nda"));
const ManageSurveys = lazy(() => import("pages/admin/survey"));
const ManageCompanyDataWallet = lazy(() =>
  import("pages/admin/company-wallet")
);
const ManageCompanyStocks = lazy(() => import("pages/admin/company-stocks"));
const ManageUsers = lazy(() => import("pages/admin/Users"));
const AdminInfo = lazy(() => import("pages/admin/info/AdminInfo"));
const AdminNotifications = lazy(() => import("pages/admin/Notification"));
const QuestionerPage = lazy(() => import("pages/admin/questioner"));
const QuestionerAnswerPage = lazy(() =>
  import("pages/admin/questioner-answer")
);
const PostRegistrationConfirmationSettings = lazy(() =>
  import("pages/admin/confirmation-settings")
);

const AdminNavigation = () => {
  //   const { user } = useAuth();
  //   console.log("user", user);
  //   if (!user?.role === "admin") return <></>;
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {/* admin panel routes */}
        <Route
          element={
            <ErrorBoundary>
              <AdminDashboardLayout />
            </ErrorBoundary>
          }
        >
          <Route index element={<Home />} />
          <Route path="manage-newsletters" element={<ManageNewsLetters />} />
          <Route path="manage-users" element={<ManageUsers />} />
          <Route path="manage-companies" element={<ManageCompanies />} />
          <Route path="manage-stay-updated" element={<ManageStayUpdated />} />
          <Route path="manage-shareholders" element={<ManageShareHolders />} />
          <Route path="wallet/sell" element={<ManageUserWalletSell />} />
          <Route path="wallet/buy" element={<ManageUserWalletBuy />} />
          <Route path="user-company-nda" element={<ManageCompanyNDA />} />
          <Route path="registration-survey" element={<ManageSurveys />} />
          <Route path="notifications" element={<AdminNotifications />} />
          <Route path="questioner" element={<QuestionerPage />} />
          <Route path="questioner-answer" element={<QuestionerAnswerPage />} />
          <Route
            path="questioner-post-registration"
            element={<PostRegistrationConfirmationSettings />}
          />
          <Route
            path="manage-company-wallet"
            element={<ManageCompanyDataWallet />}
          />
          <Route
            path="manage-company-stocks"
            element={<ManageCompanyStocks />}
          />
          <Route path="info" element={<AdminInfo />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
        {/* form builder routes */}
        <Route
          element={
            <ErrorBoundary>
              <FormBuilderLayout />
            </ErrorBoundary>
          }
        >
          <Route path="form-builder" element={<FormBuilderPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AdminNavigation;
